'use client';
import React from 'react';
import WidgetStyles from './widget.module.scss';
import { Close } from '@benzinga/themed-icons';
import { ReactComponent as PoweredByLogo } from './assets/powered-by.svg';

interface WidgetModalProps {
  open?: boolean;
  onClose?: () => void;
}

export const WidgetModal: React.FC<WidgetModalProps> = ({ onClose }) => {
  const [shouldRender, setShouldRender] = React.useState(false);

  React.useEffect(() => {
    const existingModal = document.getElementById('wnstn-widget-modal');
    setShouldRender(!existingModal);
  }, []);

  const onModalClose = React.useCallback(() => {
    const modal = document.getElementById('wnstn-widget-modal');
    if (modal) {
      modal.style.display = 'none';
    }
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={WidgetStyles.WidgetModal} id="wnstn-widget-modal" style={{ display: 'none' }}>
      <div className={WidgetStyles.WidgetModalHeader}>
        <a href="https://wnstn.ai/" rel="noreferrer" target="_blank">
          <PoweredByLogo height={33} width={323} />
        </a>
        <Close className="cursor-pointer" onClick={onModalClose} style={{ fontSize: '24px' }} />
      </div>
      <div className={WidgetStyles.WidgetModalContainer}>
        <div className="my-chat-container">
          <div className="my-chat-container-container__widget"></div>
        </div>
      </div>
    </div>
  );
};
